/**
 * Единица измерения строки. Одна на строку: фасовка и расход считаются в ней
 * же, поэтому поделить рубли за килограмм на штуки физически нельзя.
 */
export type CostUnit = 'г' | 'мл' | 'шт'

export const COST_UNITS: readonly CostUnit[] = ['г', 'мл', 'шт']

/** Строка расчёта: один продукт. */
export interface CostRow {
  id: string
  name: string
  unit: CostUnit
  /** Сколько продукта в купленной упаковке. */
  packAmount: number | null
  /** Сколько стоит упаковка целиком. */
  packPrice: number | null
  /** Сколько ушло в изделие. */
  usedAmount: number | null
}
